import { useEffect, useState } from "react";
import { fetchQuickBooksPeriodReportRange } from "@/api/fetchQuickBooksPeriodReportRange";

export const useQuickBooksDataRange = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [earliestMonth, setEarliestMonth] = useState<string | null>(null);

  useEffect(() => {
    fetchQuickBooksPeriodReportRange()
      .then((response) => {
        setEarliestMonth(response.data.earliestMonth);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return { loading, earliestMonth };
};
